// --- START OF FILE Button.js ---

// components/user/Button.js
import React from "react";
import { useNode } from "@craftjs/core";
import {
    Button as MaterialButton,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    FormControlLabel,
    TextField,
    Slider,
    Box,
    Divider,
    Typography, Switch
} from "@material-ui/core";

export const Button = ({
                           text,
                           size,
                           variant,
                           color,
                           fullWidth,
                           margin,
                           onClick
                       }) => {
    const {
        connectors: { connect, drag },
        selected,
        actions: { setProp }
    } = useNode((node) => ({
        selected: node.events.selected
    }));

    return (
        <div ref={connect} style={{ margin: `${margin}px` }}>
            <div ref={drag} style={{cursor: 'move'}}>
                <MaterialButton
                    size={size}
                    variant={variant}
                    color={color}
                    fullWidth={fullWidth}
                    onClick={() => onClick && onClick()}
                >
                    {text}
                </MaterialButton>
            </div>

            {selected && (
                <Box
                    sx={{
                        padding: 2,
                        marginTop: 2,
                        background: '#f8f9fa',
                        borderRadius: 1,
                        border: '1px solid rgba(0, 0, 0, 0.12)'
                    }}
                >
                    <Typography variant="subtitle2" gutterBottom>
                        Button Properties
                    </Typography>

                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormLabel>Button Text</FormLabel>
                        <TextField
                            value={text}
                            onChange={e => setProp(props => props.text = e.target.value)}
                            fullWidth
                            size="small"
                            margin="dense"
                        />
                    </FormControl>

                    <Divider sx={{ my: 2 }} />

                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormLabel>Size</FormLabel>
                        <RadioGroup
                            value={size}
                            onChange={e => setProp(props => props.size = e.target.value)}
                            row
                        >
                            <FormControlLabel value="small" control={<Radio />} label="Small" />
                            <FormControlLabel value="medium" control={<Radio />} label="Medium" />
                            <FormControlLabel value="large" control={<Radio />} label="Large" />
                        </RadioGroup>
                    </FormControl>

                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormLabel>Style</FormLabel>
                        <RadioGroup
                            value={variant}
                            onChange={e => setProp(props => props.variant = e.target.value)}
                            row
                        >
                            <FormControlLabel value="text" control={<Radio />} label="Text" />
                            <FormControlLabel value="outlined" control={<Radio />} label="Outlined" />
                            <FormControlLabel value="contained" control={<Radio />} label="Contained" />
                        </RadioGroup>
                    </FormControl>

                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormLabel>Color</FormLabel>
                        <RadioGroup
                            value={color}
                            onChange={e => setProp(props => props.color = e.target.value)}
                            row
                        >
                            <FormControlLabel value="default" control={<Radio />} label="Default" />
                            <FormControlLabel value="primary" control={<Radio />} label="Primary" />
                            <FormControlLabel value="secondary" control={<Radio />} label="Secondary" />
                        </RadioGroup>
                    </FormControl>

                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormControlLabel
                            control={
                                <Switch // Changed to Switch
                                    checked={fullWidth}
                                    onChange={e => setProp(props => props.fullWidth = e.target.checked)}
                                />
                            }
                            label="Full Width"
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <FormLabel>Margin</FormLabel>
                        <Slider
                            value={margin}
                            step={1}
                            min={0}
                            max={40}
                            onChange={(_, value) => setProp(props => props.margin = value)}
                            marks={[
                                { value: 0, label: '0' },
                                { value: 20, label: '20' },
                                { value: 40, label: '40' }
                            ]}
                        />
                    </FormControl>
                </Box>
            )}
        </div>
    );
};

Button.craft = {
    props: {
        text: "Click Me",
        size: "medium",
        variant: "contained",
        color: "primary",
        fullWidth: false,
        margin: 0
    }
}